module.exports = __webpack_public_path__ + "img/test-meter-icon.f5af6d88.svg";